import { render } from "./ErrorMessageNew.vue?vue&type=template&id=0a25bef3"
import script from "./ErrorMessageNew.vue?vue&type=script&lang=js"
export * from "./ErrorMessageNew.vue?vue&type=script&lang=js"

import "./ErrorMessageNew.vue?vue&type=style&index=0&id=0a25bef3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__